import styled from 'styled-components';

import { SmallParagraph } from '@genially/design-system';

/** The heading above each block of the panel, in the side layout and in full screen. */
export const SectionTitle = styled(SmallParagraph)(({ theme: { color } }) => ({
  color: color.content.reversed.default(),
}));
